import * as PIXI from 'pixi.js';
import {SoundManager, StoryManager} from '@/systems';
import {dayConfigs} from "@/config/DayConfig";

export class VignetteDisplayRadial {

  private container: PIXI.Container;
  private sprite: PIXI.Sprite;

  private bpm:number = 2;

  public setBPM(bpm:number){
    this.bpm = bpm
  }

  public setVisibility(visible:boolean){
    this.container.visible = visible
  }

  constructor(screenWidth: number, screenHeight: number) {
    this.initialization(screenWidth, screenHeight)
  }

  private async initialization(screenWidth: number, screenHeight: number){
    this.container = new PIXI.Container()

    try {
      // Load texture from path using PIXI.Assets.load (PIXI v8)
      const vignetteTexture = await PIXI.Assets.load("/assets/misc/vignette.png");

      let sprite = new PIXI.Sprite(vignetteTexture)
      this.sprite = sprite

      // Scale background to cover entire viewport (like CSS background-size: cover)
      const bgScaleX = screenWidth / vignetteTexture.width;
      const bgScaleY = screenHeight / vignetteTexture.height;

      sprite.width = screenWidth
      sprite.height = screenHeight

      this.container.visible  =true

      // sprite.scale.set(Math.max(bgScaleX, bgScaleY))
      this.container.addChild(sprite)

      let elapsed = 0;
      const pulseSpeed = 0.05; // Adjust this for faster/slower heartbeat

    } catch (error) {
      return PIXI.Texture.EMPTY;
    }

  }

  public getContainer() : PIXI.Container {
    return this.container
  }

  public startAnimation(app) {

    let elapsed = 0;
    app.ticker.remove()

    if (!this.sprite) {
      console.warn('VignetteDisplayArc: sprite not ready yet, skipping startAnimation');
      return;
    }

    this.sprite.anchor.set(0);
    this.sprite.position.set(0, 0);

    let soundManager = SoundManager.getInstance();

    let beatTimer = 0;
    let hasPlayedSound = false;
    const deltaMS = app.ticker.deltaMS;

    app.ticker.add(() => {

      if(this.bpm < 1){
        this.sprite.alpha = 0
        return
      }

      let msPerBeat = 60000 / this.bpm;

      beatTimer += deltaMS;

      // 1. Calculate progress (0 to 1) of the current beat
      const progress = beatTimer / msPerBeat;

      // 2. Use Sine to create a soft "hump"
      // Math.sin(progress * Math.PI) goes 0 -> 1 -> 0 perfectly over the beat
      const softPulse = Math.sin(progress * Math.PI);

      // 3. Play sound at the "Peak" (when progress hits 0.5)
      if (progress >= 0.5 && !hasPlayedSound) {
        console.log("SFXPLAY!")
        soundManager.play(`sfx_heart`);
        hasPlayedSound = true;
      }

      // 4. Reset for the next beat
      if (beatTimer >= msPerBeat) {
        beatTimer -= msPerBeat;
        hasPlayedSound = false; // Reset the "gate" so the sound can play again
      }

      // Apply soft alpha (0.2 base + 0.8 pulse)
      this.sprite.alpha = 0.2 + (softPulse * 0.6);
    });
  }

  public stopAnimation(app){
    app.ticker.remove()
  }

  public destroy(): void {
    this.container.destroy();
  }
}
